import { styled } from 'styled-components';
import { blockStyle } from '../../../../components/styles/Block';
import layoutStyle from '../../../../components/styles/Layout';

export const ContentBlock = styled.div`
  ${blockStyle}
  min-height: calc(100vh - 200px);
`;

export const TwoColumnLayout = styled.div`
  ${layoutStyle}
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
`;
